import * as React from 'react';

import { Container, Content } from './styles';
import { Api } from '../../../typings/api';
import DriveItemUtils from '../../../utils/driveItem';

interface SharedDocumentsProps {
	selectedResources: Api.DriveItem[];
}

const SharedDocuments = ({ selectedResources }: SharedDocumentsProps) => (
	<Container>
		{selectedResources.map((driveItem) => (
			<Content key={driveItem.id}>
				{DriveItemUtils.getDisplayName(driveItem)}
			</Content>
		))}
	</Container>
);

export default SharedDocuments;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/SharedDocuments/index.tsx